import React, { Fragment } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import Login from './pages/login/index'
import Home from './pages/home/index'
import ServerCard from './pages/serverWechat/serverCard/index'
import ServerInfo from './pages/serverWechat/Info/index'
import Activity from './pages/activityxetback/activity/index' // 海报列表
import Search from './pages/activityxetback/search/index' // 搜索二级
import SaveImg from "./pages/activityxetback/saveimg/index" // 保存海报
import Apply from "./pages/activityxetback/Apply/index" // 报名表单
import AddRecord from "./pages/addRecord/addRecord" // 报名表单


import './App.less';
function App() {
	return (
		<Fragment>
			<BrowserRouter>
				<Switch>
					<Route path="/login" component={Login}></Route>
					<Route path="/home" component={Home}></Route>
					<Route path="/servercard" component={ServerCard}></Route>
					<Route path="/info" component={ServerInfo}></Route>
					<Route path="/activity" component={Activity}></Route>
					<Route path="/search" component={Search}></Route>
					<Route path="/savimg" component={SaveImg}></Route>
					<Route path="/apply" component={Apply}></Route>
					<Route path="/addRecord" component={AddRecord}></Route>
					{/* <Route path="/channelIndex" component={ChannelIndex}>
						<Route path="/stage" component={Stage}></Route>
					</Route> */}
					<Route exact component={Home}></Route>
					<Redirect to={'/home'}></Redirect>
				</Switch>
			</BrowserRouter>
		</Fragment>

	);
}

export default App;
